import * as tslib_1 from "tslib";
import { setMailboxMessageConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveMessageOption')(function saveMessageOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.emptyDeletedItemsOnLogOut !== null) {
                        userOptions.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                        serviceObject.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                    }
                    return [4 /*yield*/, setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMessageOption.js.map